export default {
  path: 'emails-history',
  name: 'subscription/emails-history',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "subscription-show-emails-history" */ './EmailsHistory')
}
